import type { SupabaseClient } from '../client'
import type { DiscoveryData, InitiativeModule } from '../domain/discovery'
import { unwrapList, unwrapMaybe } from './_helpers'

// Nota: `updated_at` nao existe em operacoes.discovery_data (pedir no select
// retorna PostgREST 42703). `references` existe mas eh keyword PostgREST e
// nao eh necessario pro cliente. `diagnostic_reviewed` eh dead code (sem UI).
// Mantemos apenas colunas que o portal usa de verdade.
const DISCOVERY_OVERVIEW_COLUMNS = [
  'id',
  'initiative_id',
  'solution_proposal',
  'target_audience',
  'mvp_scope',
  'future_scope',
  'user_profiles',
  'product_hypotheses',
  'success_metrics',
  'scenarios',
  'journey_map_figma_url',
  'journey_map_mode',
  'journey_notes',
  'estimated_sprints',
  'modules',
  'info_architecture',
  'user_flow_figma_url',
  'figma_project_url',
  'created_at',
].join(', ')

const MODULE_COLUMNS =
  'id, initiative_id, name, description, status, scope_phase, sort_order, target_date, dependencies, functional_requirements, non_functional_requirements, persona_ids, release_id, created_at, updated_at'

/**
 * Busca o discovery_data CORE (evolution_id IS NULL) de uma iniciativa.
 * Uma iniciativa pode ter multiplas rows em discovery_data (core + uma por
 * evolution). Sem o filtro `evolution_id is null`, `.maybeSingle()` lanca
 * PGRST116 quando ha 2+ rows.
 * Retorna `null` se a iniciativa ainda nao tem discovery preenchido.
 */
export async function getDiscoveryByInitiative(
  client: SupabaseClient,
  initiativeId: number,
): Promise<DiscoveryData | null> {
  const result = await client
    .schema('operacoes')
    .from('discovery_data')
    .select(DISCOVERY_OVERVIEW_COLUMNS)
    .eq('initiative_id', initiativeId)
    .is('evolution_id', null)
    .maybeSingle()
  return unwrapMaybe(result) as unknown as DiscoveryData | null
}

/**
 * Lista módulos planejados de uma iniciativa.
 */
export async function listModulesByInitiative(
  client: SupabaseClient,
  initiativeId: number,
): Promise<InitiativeModule[]> {
  const result = await client
    .schema('operacoes')
    .from('initiative_modules')
    .select(MODULE_COLUMNS)
    .eq('initiative_id', initiativeId)
    .order('sort_order', { ascending: true, nullsFirst: false })
  return unwrapList(result) as unknown as InitiativeModule[]
}
